import React from 'react';

const ProductCardSkeleton: React.FC = () => (
  <div className="flex flex-col items-center text-center animate-pulse" role="status" aria-label="Loading product">
    <div className="aspect-[3/4] w-full bg-stone-200 rounded-sm mb-6" />
    <div className="h-4 bg-stone-200 rounded w-3/4 mb-2" />
    <div className="h-4 bg-stone-200 rounded w-1/2 mb-4" />
    <div className="h-3 bg-stone-100 rounded w-1/3" />
  </div>
);

export default ProductCardSkeleton;
